import {
  IncrementerV2 as CXIncrementor,
  IIncrementerV2 as CXIIncrementor
} from '@sanlamcx/react-ui-next-incrementer-v2';

export const Incrementor = CXIncrementor;
export type IIncrementor = CXIIncrementor;
